import React from "react";

function SettingsFour() {
  return <div>SettingsFour</div>;
}

export default SettingsFour;
